import { render, staticRenderFns } from "./ReplyBoxWrapper.vue?vue&type=template&id=71753896&scoped=true&"
import script from "./ReplyBoxWrapper.vue?vue&type=script&lang=js&"
export * from "./ReplyBoxWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ReplyBoxWrapper.vue?vue&type=style&index=0&id=71753896&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71753896",
  null
  
)

export default component.exports